import { Home } from "../components/PokemonList/pokemonLits"

const AllPokemons = () => {
    return(
        <div>
            <Home /> 
        </div>
    )
}

export { AllPokemons }